import { useTranslations } from 'next-intl'
import { toast } from 'sonner'

export const useCopyToClipboard = () => {
  const t = useTranslations()

  const copyToClipboard = async (text: string, message?: string) => {
    try {
      await navigator.clipboard.writeText(text)
      toast.success(message || t('copied'))
    } catch {
      toast.error(t('error'))
    }
  }

  return { copyToClipboard }
}
